module.exports = __webpack_public_path__ + "img/defult_man.d5870447.jpeg";